module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_33-91ba62ced202937e123047d592bdb7e2.png";